import { gameState, config } from "@js/state";
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: "StartScene",
    });
  }

  preload() {
    
      this.load.multiatlas("endConfetti", "assets/EndSceneAssets/confetti/confettiAnimNew.json", "assets/EndSceneAssets/confetti");
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    this.add.image(0, 0, "bg").setOrigin(0, 0);
    this.playButtonAnimation();

    config.audio.bgaudio = this.sound.add("bgaudio");

    config.audio.caraudio = this.sound.add("caraudio");

    config.audio.hintaudio = this.sound.add("hintaudio").setVolume(0.05);

    config.audio.correctaudio = this.sound.add("correctaudio").setVolume(0.08);
    config.audio.incorrectaudio = this.sound.add("incorrectaudio").setVolume(0.05);
    config.audio.lanechangeaudio = this.sound.add("lanechange").setVolume(0.1);

    config.audio.yayaudio = this.sound.add("yayaudio").setVolume(0.05);
    
    
   // this.load.start();

    this.carGo = this.add.sprite(config.width / 2, config.height / 2, "carGo").setVisible(false);
    this.carOn = this.add.sprite(config.width / 2, config.height / 2, "carOn");

    this.anims.create({
      key: "carOn",
      frames: this.anims.generateFrameNames("carOn", {
        start: 0,
        end: 7,
        zeroPad: 0,
        prefix: "startscreen on",
        suffix: ".png",
      }),
      frameRate: 5,
      repeat: -1,
    });

    this.carOn.play("carOn");

    this.anims.create({
      key: "carGo",
      frames: this.anims.generateFrameNames("carGo", {
        start: 0,
        end: 56,
        zeroPad: 0,
        prefix: "start screen carmoving",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  playButtonAnimation() {
    this.playButton = this.add.image(config.width / 2, config.height / 2 + 80, "play_button").setInteractive({ cursor: "pointer" });

    this.playButton.on(
      "pointerover",
      function (pointer) {
        this.playButton.setTexture("play_button_on");
      },
      this
    );

    this.playButton.on(
      "pointerout",
      function (pointer) {
        this.playButton.setTexture("play_button");
      },
      this
    );

    this.playButton.on(
      "pointerdown",
      function (pointer) {
        enablePointerEvents();
        this.playButton.setScale(0);
        this.carGo.setVisible(true);
        this.carGo.play("carGo");
        config.audio.bgaudio.setLoop(true).setVolume(0.01).play();
        this.carOn.setVisible(false);
        config.audio.caraudio.setLoop(false).setVolume(0.03).play();

        this.time.delayedCall(
          2500,
          () => {
            this.scene.start("GameScene");
            //this.scene.start("EndScene");
          },
          [],
          this
        );
      },
      this
    );
  }

  update() {}
}
